const ALERT_TYPE = {
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  CUSTOM_DANGER: 'custom danger',
};

export { ALERT_TYPE };
